import { Button, Divider, Form, Input, Tabs, Typography } from 'antd'
import { ElementSansParentProps, fullNameValidator } from 'dash/shared'
import * as React from 'react'
import { Edit, useDataProvider, useGetIdentity, useNotify, useRecordContext } from 'react-admin'
import './avatar.scss'
const { TabPane } = Tabs
// import { Box, FormControl, FormHelperText, TextField, Toolbar } from '@mui/material'
import { UserAvatar } from 'shared/atoms/UserAvatar'

const UploadableAvatar: React.FC<{ name: string; src?: string; size?: number }> = (props) => {
  const { name, src, size = 24, ...ourProps } = props

  return (
    <div className="pc__AvatarWrapper">
      <UserAvatar {...{ name, src, size }} />
      {/* <div onClick={() => alert("TODO: Avatar upload!")} role="button" className="pc__UploadOverlay" style={{
        width: size,
        height: size,
        borderRadius: size * .5,
      }}>
        Upload
      </div> */}
    </div>
  )
}

const UserEditHeader: React.FC<{ user: any }> = (props) => {
  const { user } = props

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexFlow: 'row wrap',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            marginRight: 12,
          }}
        >
          <UploadableAvatar name={user.name || user.email} src={user.avatar} size={62} />
        </div>
        <div
          style={{
            flex: '1 0',
            display: 'flex',
            flexFlow: 'column nowrap',
          }}
        >
          <Typography.Text
            strong
            style={{
              fontSize: 18,
              height: 21,
            }}
          >
            {user.name}
          </Typography.Text>
          <Typography.Text type="secondary">{user.email}</Typography.Text>
        </div>
      </div>

      <Divider />
    </>
  )
}

export const MeEdit: React.FC = () => {
  const { identity, isLoading: loadingIdentity } = useGetIdentity()

  if (loadingIdentity || identity.user == null) return null

  const editProps = {
    basePath: 'user/me',
    id: identity.user.id,
    resource: 'CurrentUser',
  }

  const validateName = [
    (value) => (value.trim().split(' ').length <= 1 ? 'must be at least 2 words (First Last)' : undefined),
  ]

  return (
    <Edit {...editProps}>
      <CustomTabs />
    </Edit>
  )
}

function CustomTabs(formProps: any) {
  const [activeTab, setActiveTab] = React.useState('profile')
  const [error, setError] = React.useState('')
  const notify = useNotify()

  const record = useRecordContext()

  const dataProvider = useDataProvider()

  const handleSubmit = async (formData) => {

    try {
      const { data: responseData } = await dataProvider.update('CurrentUser', {
        data: formData,
        id: record.id,
        previousData: record,
      })
      setError('')
      notify('Preferences saved', { type: 'success' })
    } catch (e) {
      notify('Error saving your preferences', { type: 'error' })
      setError(e.message)
    }
  }

  const formItemsLayout = { wrapperCol: { span: 12 } }
  const inputStyle = { fontSize: '1rem', padding: '6.5px 14px', borderRadius: 4 }
  const formLayout = 'vertical'

  return (
    <Tabs
      tabPosition="left"
      activeKey={activeTab}
      onChange={(newTab) => setActiveTab(newTab)}
      style={{ minWidth: '100%', padding: 24, minHeight: 640 }}
    >
      <TabPane tab="Profile" key="profile" style={{ height: '100%' }}>
        <Form {...formItemsLayout} layout={formLayout} onFinish={handleSubmit} initialValues={{ ...record }}>
          <UserEditHeader user={record} />
          <ElementSansParentProps>
            <h2>Edit Profile</h2>
          </ElementSansParentProps>
          <Form.Item
            label="Name"
            name="name"
            rules={[
              { required: true, message: 'Full name is required (First and Last)', validator: fullNameValidator },
            ]}
          >
            <Input style={inputStyle} />
            {/* <TextField variant="outlined" label='Name' /> */}
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: 'Email is required', type: 'email' }]}
          >
            <Input style={inputStyle} />
          </Form.Item>
          <Form.Item label="Phone" name="phone" rules={[{ type: 'number', message: 'Phone must be a number' }]}>
            <Input style={inputStyle} />
          </Form.Item>
          <Form.Item
            label="Homepage"
            name="homepage"
            rules={[{ type: 'url', message: 'Homepage must be a valid URL' }]}
          >
            <Input style={inputStyle} />
          </Form.Item>
          <Error error={error} />
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
      </TabPane>

      {/* <TabPane tab="Stacks" key="stack">
          <div style={{
            display: 'flex',
            flexFlow: 'column nowrap'
          }}>
            <UserEditHeader user={formProps.record} />

            <ElementSansParentProps>
              <h2>Your Stacks</h2>
            </ElementSansParentProps>

            <AutocompleteArrayInput
              {...inputProps}
              source="stacks"
              choices={[
                { id: 'cloudflare', name: 'Cloudflare' },
                { id: 'gatsby', name: 'Gatsby' },
                { id: 'go', name: 'Go' },
                { id: 'heroku', name: 'Heroku' },
                { id: 'hugo', name: 'Hugo CMS' },
                { id: 'javascript', name: 'Javascript' },
                { id: 'jekyll', name: 'Jekyll' },
                { id: 'netlify', name: 'Netlify' },
                { id: 'react_native', name: 'React Native' },
                { id: 'react', name: 'React' },
                { id: 'swift', name: 'Swift' },
                { id: 'typescript', name: 'Typescript' },
                { id: 'vue', name: 'Vue' },
                { id: 'ruby', name: 'Ruby' },
                { id: 'python', name: 'Python' },
                { id: 'clojure', name: 'Clojure' },
                { id: 'java', name: 'Java' },
                { id: 'SQL', name: 'SQL' },
                { id: 'nosql', name: 'NoSQL' },
                { id: 'mariadb', name: 'MariaDB' },
                { id: 'postgres', name: 'Postgres' },
                { id: 'kubernetes', name: 'Kubernetes' },
                { id: 'docker', name: 'docker' },
                { id: 'wordpress', name: 'Wordpress' },
                { id: 'shopify', name: 'Shopify' },
              ]}
            />
          </div>
        </TabPane>

        <TabPane tab="Identities" key="identities">
          <div style={{
            display: 'flex',
            flexFlow: 'column nowrap'
          }}>
            <UserEditHeader user={formProps.record} />

            <ElementSansParentProps>
              <h2>Identities</h2>
            </ElementSansParentProps>
            <TextInput {...inputProps} source="github" label="GitHub" />
            <TextInput {...inputProps} source="slack" />
            <TextInput {...inputProps} source="google" />
            <TextInput {...inputProps} source="apple" />
          </div>
        </TabPane> */}

      <TabPane tab="Security" key="security">
        <Form {...formItemsLayout} layout={formLayout} onFinish={handleSubmit}>
          <UserEditHeader user={record} />
          <ElementSansParentProps>
            <h2>Change Password</h2>
          </ElementSansParentProps>
          <Form.Item label="New Password" name="password">
            <Input.Password style={inputStyle} />
          </Form.Item>
          <Error error={error} />
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
      </TabPane>
    </Tabs>
  )
}

const Error: React.FC<{error: any}> = ({ error }) => <>{error && <div style={{ color: '#c62828', marginBottom: 24 }}>{error}</div>}</>
